import React from "react";
import { Col, Row } from "react-bootstrap";
import { Form, Progress } from "antd";

import useWindowSize from "../../utils/useWindowSize";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import Logout from "../../containers/Pages/Login/Logout";
import { connect } from "react-redux";
import { getProgress } from "../../redux/progressBar/action";
const PartnerPortalStatusBar = (props) => {
  const FormItem = Form.Item;
  let progress = 0,
    label = `${progress}% Registration  Completed`;

  const { width } = useWindowSize();

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  const partnerSidebarDtoList =
    props?.partnerSidebarDtoList?.length > 0
      ? props?.partnerSidebarDtoList
      : [];

  const EngagementDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "EngagementDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const FirmDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "FirmDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const BranchDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "BranchDetails")
      ?.status === "COMPLETE"
      ? true
      : false;
  const TeamDetailStatus =
    partnerSidebarDtoList?.find((item) => item.page === "TeamDetails")
      ?.status === "COMPLETE"
      ? true
      : false;

  const DocumentStatus =
    partnerSidebarDtoList?.find((item) => item.page === "Documents")?.status ===
    "COMPLETE"
      ? true
      : false;

  if (EngagementDetailStatus) {
    progress += 20;

    label = `${progress}% Registration  Completed`;
  }

  if (FirmDetailStatus) {
    progress += 20;
    label = `${progress}% Registration  Completed`;
  }

  if (BranchDetailStatus) {
    progress += 20;
    label = `${progress}% Registration   Completed`;
  }

  if (TeamDetailStatus) {
    progress += 20;
    label = `${progress}% Registration   Completed`;
  }

  if (DocumentStatus) {
    progress += 20;
    label = `${progress}% Registration Completed`;
  }

  return (
    <div>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
          <Col md={8} className="search-bar Engagementprogess">
            {!props.cet && (
              <FormItem name="PartnerManagementsearch" label={label}>
                <Progress percent={progress} />
              </FormItem>
            )}
          </Col>
          {width > 786 && (
            <Col md={4}>
              <div className="login-profie">
                <div className="img-sec">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                        props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                        props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>

                <div className="content-login">
                  <h4>{props.userDetail?.userName}</h4>
                  <h5>{props.userDetail?.roleName}</h5>
                  <div className="content-login-data">
                    {props.userDetail?.loggedInRoleType === "PARTNER" && (
                      <ChangePassword />
                    )}

                    <div className="admin-small-space"> </div>
                    <Logout />
                    {/* <h6>Change Password | Logout</h6> */}
                  </div>
                </div>
              </div>
            </Col>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetail: state?.auth?.userData,
    partnerSidebarDtoList: state.partnerSidebar?.partnerSidebarDtoList,
    auth: state?.auth,
    editPartner: state?.editPartner?.editPartner,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: (data) => dispatch(getProgress(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerPortalStatusBar);
